// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import InputBlurChange from "metabase/common/components/InputBlurChange";

export const NumericInputBlurChange = styled(InputBlurChange)`
  width: auto;
`;
